function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.8,
  d: "M13.92 50.94H2.57V17.81h59v33.13H49.76"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.8,
  d: "M14.38 40.04h35.38v20.42H14.38zM14.77 17.1V3.54h34.6V17.1"
});

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+cHJpbnQ8L3RpdGxlPjxwb2x5bGluZSBwb2ludHM9IjEzLjkyIDUwLjk0IDIuNTcgNTAuOTQgMi41NyAxNy44MSA2MS41NyAxNy44MSA2MS41NyA1MC45NCA0OS43NiA1MC45NCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjgiLz48cmVjdCB4PSIxNC4zOCIgeT0iNDAuMDQiIHdpZHRoPSIzNS4zOCIgaGVpZ2h0PSIyMC40MiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjgiLz48cG9seWxpbmUgcG9pbnRzPSIxNC43NyAxNy4xIDE0Ljc3IDMuNTQgNDkuMzcgMy41NCA0OS4zNyAxNy4xIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjQuOCIvPjwvc3ZnPg==";
export { SvgPrint as ReactComponent };